/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/18/20
 *
 */
import AddonItem from "@shared/Subscription/Addons/AddonItem";
import DriveStorageFeature from "@shared/Subscription/Features/DriveStorageFeature";

let SIZE_1GB = 1 * 1024 * 1024 * 1024

export default class DriveStorageAddon extends AddonItem {


	constructor() {
		super();
		this.price = 4.99
		this.units = 10 * SIZE_1GB
		this.name = "10GB drive extension pack"
		this.featureItems.push(new DriveStorageFeature(this.units))
	}
}
